import ko from 'knockout';
import BidLandscapeModel from '@bingads-webui-campaign-legacy/bidlandscape/viewmodel/bid-landscape';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/bidlandscape');

export default class extends BidLandscapeModel {
  constructor(parentItem, parentView) {
    super(parentItem, parentView);

    this.entityType('keyword');
    this.tableBidText = ko.computed(() => {
      return i18n.get('BidLandscape_kpiMaxCpC');
    });
  }
}
